import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getProperty, decodeUtf8, checkBoolean, isEmptyArray, returnEmpty } from '@core/_utils/tools.utils';
import { defTitleCustMenu } from '@documalis/_const/const';

@Injectable()
export class RightService {
    public menuItem = {
        TRTxt: false, // Recherche plein texte
        TRBrs: false, // Recherche arbrescente
        TRVar: false, // Recherche par index
        TQMod: false, // Modif requêtes personnalisées
        TRBsk: false, // Bannettes personnelles
        TPan: false, // Accès au panier
        TStat: false, // Statistiques
        TExp: false, // Exportation
        TDos: false, // Accès aux dossier : non implémenté
        TMov: false,
        TPref: true,
    };

    public typeAction = {
        TDlOri: false, // Téléchargement original
        TDlCpy: false, // Téléchargement copie
        TDVar: false, // Affichage des index
        TIdx: false, // Modification des index
        TDAft: false, // Affichage des pièces jointes du document
        TDCom: false, // Affichage commentaire
        TAddCom: false, // Ajout commentaire
        TDTra: false, // Affichage trace
        TStamp: false, // Ajout d'un tampon
        TSign: false, // Ajout d'une signature
        TPost: false, // Ajout d'une annotation
        TMov: false, // Déplacement du document
        TBList: false, // Liste des bannettes contenant le document
        TExp: false, // Exportation des documents
        THis: false, // Historisation : non implémenté V6
        TDel: false, // Suppression d'un document
        TMail: false, // Envoi par Email
        TFax: false, // Envoi par télécopie : non implémenté V5
        TDif: false, // Diffusion : non implémenté V5
        TSaf: false, // Envoi vers coffre fort : non implémenté V5
        TStat: false, // Statistiques
        TGVer: false, // Consultation des versions
        TVVer: false, // Ajout d'une nouvelle version
        TProc: false, // Non implémenté V5
        TAtfAdd: true, // Interdire l'ajout de pièces jointes
        TAtfDel: true, // Interdire la suppression de pièces jointes
        TAtfCnv: true, // Interdire la conversion de pièces jointes
        TGAudit: false,
        TGInfo: true,
        TGAct: false,
        TGBas: false,
        TGExt: false,
        TGGrp: false,
        TDInfo: false, // Affichage info
        TBAct: false,
        TGText: false,
        TGPict: false,
        TGBigPict: false,
        TGPreV: false,
        TGViewPdf: false, // Affichage vue pdf
        TBPub: false,
        TBMail: false,
        TBDis: false,
        TBCol: false,
        TBFlow: false,
        TPro: false, // Non implémenté V5
        TZip: false,
        TCct: false,
        TVVar: false,
        TVTrc: false,
        TVCom: false,
        TVLis: false,
        TVInf: false,
        TZipZDoc: false,
        TSplPdf: false,
        TBskLastIn: false,
        TBskFirstIn: false,
        TBskUrgent: false,
        TBskDate: false,
        TZipCpy: false,
        TDelDoc: false,
        TRen: false,
    };

    private noRecur: any[];
    private profil: any[];
    private recur: any[];
    private root: any[];

    public actionDisplay = {
        TPan: false, // Accès au panier
        TMov: false, // Déplacement du document
        TExp: false, // Exportation
        TStat: false, // Statistiques
        TMail: false, // Envoi par Email
        TRBsk: false, // Bannettes personnelles
        TDel: false, // Suppression d'un document
    };

    constructor(private translate: TranslateService) {
        this.noRecur = new Array();
        this.profil = new Array();
        this.recur = new Array();
        this.root = new Array();
        this.initialize();
        this.initTypeAction();
    }

    public getSearchMenu() {
        let wItems = [];
        let wMenu = [];

        if (this.menuItem.TRTxt) {
            wItems.push({ label: this.translate.instant('FullText'), icon: 'icons8-recherche-immobili-re', routerLink: ['/fulltextsearch'] });
        }
        if (this.menuItem.TRBrs) {
            wItems.push({ label: this.translate.instant('Tree'), icon: 'icons8-dossier-de-recherche', routerLink: ['/page-tree-search'] });            
        }
        if (this.menuItem.TRVar) {
            wItems.push({ label: this.translate.instant('Index'), icon: 'icons8-formulaire', routerLink: ['/page-request-list'] });
        }
        if (this.menuItem.TPan) {
            wItems.push({ label: this.translate.instant('Basket'), icon: 'icons8-add-basket', routerLink: ['/page-basket'] });
        }
        if (this.menuItem.TRTxt || this.menuItem.TRBrs || this.menuItem.TRVar || this.menuItem.TPan) {
            wMenu.push({ id: 'SrchMenu', label: this.translate.instant('Search'), icon: 'pi pi-search', items: wItems, forceRoot: false, });
        }
        return wMenu;
    }

    public getBskMenu() {
        let wItems = [];
        if (this.menuItem.TRBsk) {
            wItems.push({
                id: 'BaskMenu',
                label: this.translate.instant('Baskets'),
                icon: 'icons8-bo-te-de-r-ception',
                routerLink: ['/page-basket-list'],
                forceRoot: true,
            });
        }
        return wItems;
    }

    public getToolsMenu(aRole) {
        let wItems = [];
        if (this.menuItem.TRVar && this.menuItem.TQMod) {
            wItems.push({ label: this.translate.instant('Mg_Query'), icon: 'pi pi-filter', routerLink: ['/requests'] });
            wItems.push({ label: this.translate.instant('Mg_Display'), icon: 'pi pi-fw pi-desktop', routerLink: ['/results'] });
        }
        return wItems;
    }

    public getRight(aInfos) {
        let wRoot = getProperty(aInfos, 'BaseRoot');
        let wPath = getProperty(aInfos, 'StoragePath');
        let wWrkProfil: any[];
        wWrkProfil = [];
        this.initTypeAction();
        this.getProfile(wRoot, wPath, this.recur, wWrkProfil, true);
        this.getProfile(wRoot, wPath, this.noRecur, wWrkProfil, false);
        this.updateAction(this.typeAction, this.profil, wWrkProfil);
    }

    public isActionAllow(aRoot, aPath, aTypeAction) {
        let wWrkProfil: any[];
        let wRes = -1;
        let wFind = false;
        wWrkProfil = new Array();
        this.getProfile(aRoot, aPath, this.recur, wWrkProfil, true);
        this.getProfile(aRoot, aPath, this.noRecur, wWrkProfil, false);
        for (let i = 0; i < wWrkProfil.length; i++) {
            if (wWrkProfil[i] === '*') {
                wRes++;
            } else {
                wFind = this.getActionAllow(aTypeAction, wWrkProfil[i]);
                if (wFind) {
                    wRes++;
                }
            }
        }
        return wRes !== -1;
    }

    private getActionAllow(aTypeAction, aWrkProfil) {
        let wFind = false;
        let wIndex = -1;
        wIndex = this.profil.findIndex((item) => item.name === aWrkProfil);
        if (wIndex !== -1) {
            wFind = this.searchAction(aTypeAction, this.profil[wIndex].profillist);
        }
        return wFind;
    }

    private searchAction(aTypeAction, aObject: any) {
        return aObject.find((value) => value[aTypeAction]) ? true : false;
    }

    public setBskRights(aBskRights) {
        this.updateActionDetailBsk(this.typeAction, aBskRights);
    }

    private updateAction(aTypeAction, aProfil, aWrkProfil) {
        for (let i = 0; i < aWrkProfil.length; i++) {
            if (aWrkProfil[i] === '*') {
                this.activAll(aTypeAction, true);
                this.forceAction('TAtfAdd', false);
                this.forceAction('TAtfDel', false);
                this.forceAction('TAtfCnv', false);
                break;
            } else {
                this.updateFromProfile(aTypeAction, aProfil, aWrkProfil[i]);
            }
        }
    }

    private updateFromProfile(aTypeAction, aProfil, aName) {
        let wIndex = -1;
        wIndex = aProfil.findIndex((item) => item.name === aName);
        if (wIndex !== -1) {
            for (let i = 0; i < aProfil[wIndex].profillist.length; i++) {
                this.updateActionDetail(aTypeAction, aProfil[wIndex].profillist[i]);
            }
        }
    }

    private updateActionDetailBsk(aTypeAction, aObject) {
        for (var key in aObject) {
            if (aObject.hasOwnProperty(key)) {
                aTypeAction[key] = aObject[key];
            }
        }
    }

    private updateActionDetail(aTypeAction, aObject) {
        for (var key in aObject) {
            if (aObject.hasOwnProperty(key)) {
                if (aObject[key] === true) {
                    aTypeAction[key] = true;
                }
            }
        }
    }

    private activAll(aTypeAction, aValue) {
        for (var key in aTypeAction) {
            if (aTypeAction.hasOwnProperty(key)) {
                aTypeAction[key] = aValue;
            }
        }
    }

    private getProfile(aRoot, aPath, aList, aWrkProfil, aRecur) {
        let wRootPathTest = aRoot + '\\' + aPath;
        let wRootPath = '';

        for (let i = 0; i < aList.length; i++) {
            wRootPath = aList[i].root + '\\' + aList[i].path;
            wRootPath = wRootPath.toUpperCase();
            wRootPathTest = wRootPathTest.toUpperCase();
            if (aRecur) {
                if (this.isInclude(wRootPathTest, wRootPath)) {
                    this.addWrkProfile(aList, aWrkProfil, i);
                }
            } else {
                if (wRootPathTest === wRootPath) {
                    this.addWrkProfile(aList, aWrkProfil, i);
                    break;
                }
            }
        }
    }

    private addWrkProfile(aList, aWrkProfil, aIndex) {
        for (let j = 0; j < aList[aIndex].profillist.length; j++) {
            aWrkProfil.push(aList[aIndex].profillist[j].name);
        }
    }

    private isInclude(aValue, aValueInclude) {
        let wRes = false;
        let wPatht = '';
        if (aValueInclude.length <= aValue.length) {
            wPatht = aValue.substring(0, aValueInclude.length);
            if (aValueInclude === wPatht) {
                wRes = true;
            }
        } else {
            wPatht = aValueInclude.substring(0, aValue.length);
            if (wPatht === aValue) {
                wRes = true;
            }
        }
        return wRes;
    }

    public setRight(aValue) {
        this.initialize();
        this.initTypeAction();
        let datajson = JSON.parse(decodeUtf8(aValue));
        datajson.function.forEach((item) => {
            this.menuItem = {
                ...this.menuItem,
                ...item,
            };
        });
        datajson.norecur.forEach((item) => {
            this.noRecur.push(item);
        });
        datajson.profil.forEach((item) => {
            this.profil.push(item);
        });
        datajson.recur.forEach((item) => {
            this.recur.push(item);
        });
        datajson.root.forEach((item) => {
            this.root.push(item);
        });
    }

    public updateMenu(allowSearch: boolean, allowBasket: boolean, allowPref: boolean) {
        this.forceMenu('TRBsk', allowBasket);
        this.forceMenu('TPref', allowPref);    
    }

    public getCustTitle() {
        let wInternal = JSON.parse(atob(localStorage.getItem('intern')));
        let wMenu = returnEmpty(wInternal.titleCust);
        return wMenu === '' ? defTitleCustMenu : wInternal.titleCust;
    }

    private basketsNotEmpty() {
        let wRes = true;
        let wBasket: any;
        wBasket = JSON.parse(localStorage.getItem('BasketMailList'));
        wRes = wRes && isEmptyArray(wBasket);
        wBasket = JSON.parse(localStorage.getItem('BasketCollectList'));
        wRes = wRes && isEmptyArray(wBasket);
        wBasket = JSON.parse(localStorage.getItem('BasketPublishList'));
        wRes = wRes && isEmptyArray(wBasket);
        wBasket = JSON.parse(localStorage.getItem('BasketActionList'));
        wRes = wRes && isEmptyArray(wBasket);
        wBasket = JSON.parse(localStorage.getItem('BasketInputList'));
        wRes = wRes && isEmptyArray(wBasket);
        wBasket = JSON.parse(localStorage.getItem('BasketOutputList'));
        wRes = wRes && isEmptyArray(wBasket);
        wBasket = JSON.parse(localStorage.getItem('BasketSystemList'));
        wRes = wRes && isEmptyArray(wBasket);
        return wRes;
    }

    public getDisplayAction(aIsAdmin) {
        if (aIsAdmin) {
            this.forceDisplayAction('TPan', true);
            this.forceDisplayAction('TMov', true);
            this.forceDisplayAction('TExp', true);
            this.forceDisplayAction('TStat', true);
            this.forceDisplayAction('TMail', true);
            this.forceDisplayAction('TRBsk', true);
            this.forceDisplayAction('TDel', true);
        } else {
            this.readRigths('TPan');
            this.readRigths('TMov');
            this.readRigths('TExp');
            this.readRigths('TStat');
            this.readRigths('TMail');
            this.readRigths('TRBsk');
            this.readRigths('TDel');
            // Surcharge avec valeur trouvé pour le menu (dépend de la config utilisateur)
            this.forceDisplayAction('TRBsk', this.menuItem.TRBsk);
        }
    }
    
    private readRigths(aTypeAction) {
        let wRes = false;
        wRes = this.readRigthDir(this.recur, aTypeAction);
        if (wRes === false) {
            wRes = this.readRigthDir(this.noRecur, aTypeAction);
        }
        this.forceDisplayAction(aTypeAction, wRes);
    }

    private readRigthDir(aProfil, aTypeAction) {
        let wRes = false;
        for (const item of aProfil) {
            for (const profil of item.profillist) {
                if (profil.name === '*') {
                    wRes = true;
                    break;
                } else {
                    wRes = this.getActionAllow(aTypeAction, profil.name);
                    if (wRes === true) {
                        break;
                    }
                }
            }
            if (wRes === true) {
                break;
            }            
        }
        return wRes;
    }

    private forceDisplayAction(aTypeAction, aValue) {
        this.actionDisplay[aTypeAction] = aValue;
    }

    private getAllowSearch(aData) {
        let wRes = false;
        if (aData) {
            if (aData.AllowSearch) {
                wRes = checkBoolean(aData.AllowSearch);
            }
        }
        return wRes;
    }

    private getAllowBasket(aData) {
        let wRes = false;
        if (aData) {
            if (aData.AllowBasket) {
                wRes = checkBoolean(aData.AllowBasket);
            }
        }
        return wRes;
    }

    private initialize() {
        this.noRecur = [];
        this.profil = [];
        this.recur = [];
        this.root = [];
        this.menuItem = {
            TRTxt: false,
            TRBrs: false,
            TRVar: false,
            TQMod: false,
            TRBsk: false,
            TPan: false,
            TStat: false,
            TExp: false,
            TDos: false,
            TMov: false,
            TPref: true,
        };
    }

    public initTypeAction() {
        this.activAll(this.typeAction, false);
    }

    public forceAction(aTypeAction, aValue) {
        this.typeAction[aTypeAction] = aValue;
    }

    public verifyRight(aSelectedDocs, aAction) {
        let wDocList = new Array();
        aSelectedDocs.forEach((item) => {
            if (this.isActionAllow(item.doc_root, item.doc_path, aAction)) {
                wDocList.push(item);
            }
        });
        return wDocList;
    }

    private forceMenu(aTypeAction, aValue) {
        this.menuItem[aTypeAction] = aValue;
    }
}
